import { Box } from "@mui/material";
import React from "react";
import { InputDate } from "../../controls";
import moment from "moment";
import { subDays } from "date-fns";
import dayjs from "dayjs";

const DateRange = ({ sortDate, setSortDate }) => {
  const handleDate = (name, newVal) => {
    setSortDate((x) => ({ ...x, [name]: newVal }));
  };

  return (
    <Box className="flex items-center justify-center gap-2 w-full md:max-w-[380px]">
      <InputDate
        size="small"
        variant="outlined"
        name="fromDate"
        value={sortDate.fromDate}
        views={["day", "month", "year"]}
        openTo="day"
        minDate={new Date("01/01/2000")}
        maxDate={subDays(new Date(sortDate.toDate), 1)}
        onChange={(date) =>
          handleDate("fromDate", date ? dayjs(date).format("MM/DD/YYYY") : "")
        }
      />
      <span className="text-[16px] text-gray-500">TO</span>
      <InputDate
        size="small"
        variant="outlined"
        name="toDate"
        value={sortDate.toDate}
        minDate={moment(sortDate.fromDate, "MM/DD/YYYY").add(1, "days")}
        views={["day", "month", "year"]}
        openTo="day"
        onChange={(date) =>
          handleDate("toDate", date ? dayjs(date).format("MM/DD/YYYY") : "")
        }
      />
    </Box>
  );
};

export default DateRange;
